import { render, staticRenderFns } from "./pageStastic.vue?vue&type=template&id=0f12150c&scoped=true&"
import script from "./pageStastic.vue?vue&type=script&lang=js&"
export * from "./pageStastic.vue?vue&type=script&lang=js&"
import style0 from "./pageStastic.vue?vue&type=style&index=0&id=0f12150c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12150c",
  null
  
)

export default component.exports